<template>
	<div class="generalization-detail">
		<div class="body" :style="{ height: 'calc(' + height + 'px - 80px)' }">
			<div class="title">
				{{ data.title }}
			</div>
			<vue-markdown :source="data.content" id="markdown-content" />
		</div>
		<div slot="footer" class="button-box">
			<el-button @click="handleClose" size="small">{{ $t("common.cancel") }}</el-button>
			<el-button @click="handleSend(data)" size="small" :type="data.is_send ? 'default' : 'primary'">
				{{ data.is_send ? $t("generalization.sendAgain") : $t("generalization.send") }}</el-button
			>
		</div>
	</div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
	name: "GeneralizationDetail",
	components: {
		VueMarkdown,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
		height: {
			type: Number,
			required: false,
			default: null,
		},
	},
	methods: {
		handleClose() {
			this.$emit("close-dialog");
		},
		handleSend() {
			this.$emit("send", this.data);
		},
	},
};
</script>

<style lang="less" scoped>
.generalization-detail {
	.el-dialog__body {
		padding: 0px 30px 0px 30px !important;
	}
	.body {
		margin-bottom: 40px;
		padding: 0px 30px;
		overflow: auto;
		.title {
			margin-bottom: 15px;
		}
		/deep/ #markdown-content {
			img {
				max-width: 100%;
			}
		}
	}
	.button-box {
		margin-top: 10px;
		padding: 0px 30px;
		display: flex;
		justify-content: flex-end;
	}
}
</style>
